import React from 'react';

export default function SubFooter() {
  return (
    <section className="sub">
      <div className="container">
        <div className="row">
          <div className="col-sm-4 col-md-3">
            <h5>
              <a
                href="http://www.bd.com/en-us/offerings"
                target="_blank"
                rel="noopener noreferrer"
              >
                Offerings
              </a>
            </h5>
            <ul>
              <li>
                <a
                  href="http://www.bd.com/en-us/offerings/capabilities"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Capabilities
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/offerings/brands"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Brands
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/offerings/integrated-solutions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Integrated solutions
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Catalogs
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-4 col-md-3">
            <h5>
              <a
                href="http://www.bd.com/en-us/company"
                target="_blank"
                rel="noopener noreferrer"
              >
                Company
              </a>
            </h5>
            <ul>
              <li>
                <a
                  href="http://www.bd.com/en-us/company/contact-us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact us
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/company/careers"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/company/sustainability-at-bd"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sustainability
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/company/trading-partners/bd-suppliers"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Suppliers
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/company/news-and-media"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  News
                </a>
              </li>
              <li>
                <a
                  href="http://investors.bd.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Investors
                </a>
              </li>
              <li>
                <a
                  href="https://www.bd.com/en-us/resource-and-education/documentation-landing-page?lastUpdate=all-dates&documentTypes_fullstring=Video&s=documentTypes_fullstring"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Video gallery
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-4 col-md-3">
            <h5>
              <a
                href="http://www.bd.com/en-us/clinical-excellence"
                target="_blank"
                rel="noopener noreferrer"
              >
                Clinical Excellence
              </a>
            </h5>
            <ul>
              <li>
                <a
                  href="https://www.bd.com/en-us/resource-and-education/documentation-landing-page?lastUpdate=all-dates&documentTypes_fullstring=Case%20Study&s=documentTypes_fullstring"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Case studies
                </a>
              </li>
              <li>
                <a
                  href="https://www.bd.com/en-us/resource-and-education/event-landing-page?startDate=all-dates"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Events
                </a>
              </li>
              <li>
                <a
                  href="https://www.bd.com/en-us/resource-and-education/training-landing-page?startDate=all-dates"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Training
                </a>
              </li>
            </ul>
          </div>
          <div className="clear visible-sm"></div>
          <div className="col-sm-4 col-md-3">
            <h5>
              <a
                href="http://www.bd.com/en-us/support"
                target="_blank"
                rel="noopener noreferrer"
              >
                Support
              </a>
            </h5>
            <ul>
              <li>
                <a
                  href="http://www.bd.com/en-us/support"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Technical support
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Customer portals
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/support/alerts-and-notices"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Alerts and notices
                </a>
              </li>
              <li>
                <a
                  href="http://www.bd.com/en-us/support/product-security-and-privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Product security and privacy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
